import React, { useState, useMemo } from "react";
import {
  Container,
  Typography,
  Box,
  Stack,
  ThemeProvider,
  createTheme,
  CssBaseline,
  IconButton,
} from "@mui/material";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import Brightness7Icon from "@mui/icons-material/Brightness7";

import Entropy from "./components/userInteractions/Entropy";
import WordsCount from "./components/userInteractions/WordsCount";
import PassPhrase from "./components/userInteractions/PassPhrase";
import Status from "./components/Status";
import DerivedWallets from "./components/derivedWallets";
import SelectNetwork from "./components/userInteractions/SelectNetwork";

function App() {
  const [wordsCount, setWordsCount] = useState(24);
  const [diceNumbers, setDiceNumbers] = useState([]);
  const [passPhrase, setPassPhrase] = useState("");
  const [network, setNetwork] = useState(60);
  const [mode, setMode] = useState("light");

  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          mode,
        },
      }),
    [mode]
  );

  const toggleTheme = () => {
    setMode((prevMode) => (prevMode === "light" ? "dark" : "light"));
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", position: "relative" }}>
          <Typography variant="h1" component="h1" align="center" gutterBottom>
            Mnemonic Generator
          </Typography>
          <IconButton sx={{ position: "absolute", right: 0 }} onClick={toggleTheme} color="inherit">
            {theme.palette.mode === "dark" ? <Brightness7Icon /> : <Brightness4Icon />}
          </IconButton>
        </Box>

        {/* Top Row */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            gap: theme.spacing(4),
          }}
        >
          {/* Top-Left: Controls */}
          <Box
            sx={{
              flex: { md: "1 1 50%" },
              minWidth: 0,
            }}
          >
            <Stack spacing={2}>
              <WordsCount
                wordsCount={wordsCount}
                setWordsCount={setWordsCount}
              />
              <Entropy
                diceNumbers={diceNumbers}
                setDiceNumbers={setDiceNumbers}
                wordsCount={wordsCount}
              />
              <SelectNetwork setNetwork={setNetwork} />
              <PassPhrase setPassPhrase={setPassPhrase} />
            </Stack>
          </Box>

          {/* Top-Right: Status */}
          <Box
            sx={{
              flex: { md: "1 1 50%" },
              minWidth: 0,
            }}
          >
            <Status
              wordsCount={wordsCount}
              diceNumbers={diceNumbers}
              passPhrase={passPhrase}
            />
          </Box>
        </Box>

        {/* Bottom Row */}
        <Box sx={{ mt: 4 }}>
          <DerivedWallets
            diceNumbers={diceNumbers}
            passPhrase={passPhrase}
            wordsCount={wordsCount}
            network={network}
          />
        </Box>
      </Container>
    </ThemeProvider>
  );
}

export default App;
